module.exports = __webpack_public_path__ + "media/images/icons/outlined/insert-row-right-6e75eb54bf365ac33f984f50ce6bada3.svg";